var _rect, _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _path8, _circle, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide4325(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 165,
    viewBox: "0 0 220 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 165,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6953 108.281H64.0234V130.625C64.0234 132.286 62.6768 133.633 61.0156 133.633H50.7031C49.042 133.633 47.6953 132.286 47.6953 130.625V108.281Z",
    fill: "#3747AF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0781 125.438C52.0094 125.438 51.9492 125.412 51.8977 125.36C51.8461 125.309 51.8203 125.248 51.8203 125.18C51.8203 125.137 51.8246 125.089 51.8332 125.038L55.0301 116.698C55.0645 116.612 55.1117 116.543 55.1719 116.491C55.232 116.44 55.3223 116.414 55.4426 116.414H56.3191C56.4309 116.414 56.5168 116.44 56.577 116.491C56.6457 116.543 56.6973 116.612 56.7316 116.698L59.9156 125.038C59.9328 125.089 59.9414 125.137 59.9414 125.18C59.9414 125.248 59.9156 125.309 59.8641 125.36C59.8125 125.412 59.7523 125.438 59.6836 125.438H59.0262C58.923 125.438 58.8457 125.412 58.7941 125.36C58.7512 125.309 58.7211 125.261 58.7039 125.218L57.9949 123.388H53.7668L53.0578 125.218C53.0492 125.261 53.0191 125.309 52.9676 125.36C52.916 125.412 52.8387 125.438 52.7355 125.438H52.0781ZM54.1406 122.279H57.6211L55.8809 117.703L54.1406 122.279Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7422 108.281H82.0703V130.625C82.0703 132.286 80.7237 133.633 79.0625 133.633H68.75C67.0888 133.633 65.7422 132.286 65.7422 130.625V108.281Z",
    fill: "#38AABA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4121 125.438C73.2832 125.438 73.1801 125.407 73.1027 125.347C73.034 125.287 72.9781 125.205 72.9352 125.102L70.0605 116.814C70.0434 116.762 70.0348 116.715 70.0348 116.672C70.0348 116.603 70.0605 116.543 70.1121 116.491C70.1637 116.44 70.2238 116.414 70.2926 116.414H70.9629C71.066 116.414 71.1434 116.444 71.1949 116.504C71.2551 116.556 71.2895 116.603 71.298 116.646L73.8246 123.955L76.3512 116.646C76.3684 116.603 76.4027 116.556 76.4543 116.504C76.5059 116.444 76.5832 116.414 76.6863 116.414H77.3566C77.4254 116.414 77.4855 116.44 77.5371 116.491C77.5973 116.543 77.6273 116.603 77.6273 116.672C77.6273 116.715 77.6188 116.762 77.6016 116.814L74.7141 125.102C74.6797 125.205 74.6238 125.287 74.5465 125.347C74.4777 125.407 74.3789 125.438 74.25 125.438H73.4121Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7891 108.066H100.117V130.41C100.117 132.071 98.7705 133.418 97.1094 133.418H86.7969C85.1357 133.418 83.7891 132.071 83.7891 130.41V108.066Z",
    fill: "#38BA64"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1719 125.223C88.1031 125.223 88.043 125.197 87.9914 125.145C87.9398 125.094 87.9141 125.034 87.9141 124.965C87.9141 124.922 87.9184 124.875 87.927 124.823L91.1238 116.483C91.1582 116.397 91.2055 116.328 91.2656 116.277C91.3258 116.225 91.416 116.199 91.5363 116.199H92.4129C92.5246 116.199 92.6105 116.225 92.6707 116.277C92.7395 116.328 92.791 116.397 92.8254 116.483L96.0094 124.823C96.0266 124.875 96.0352 124.922 96.0352 124.965C96.0352 125.034 96.0094 125.094 95.9578 125.145C95.9063 125.197 95.8461 125.223 95.7773 125.223H95.1199C95.0168 125.223 94.9395 125.197 94.8879 125.145C94.8449 125.094 94.8148 125.046 94.7977 125.004L94.0887 123.173H89.8605L89.1516 125.004C89.143 125.046 89.1129 125.094 89.0613 125.145C89.0098 125.197 88.9324 125.223 88.8293 125.223H88.1719ZM90.2344 122.064H93.7148L91.9746 117.488L90.2344 122.064Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.836 108.066H118.164V130.41C118.164 132.071 116.817 133.418 115.156 133.418H104.844C103.183 133.418 101.836 132.071 101.836 130.41V108.066Z",
    fill: "#F7D051"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.733 125.223C109.647 125.223 109.574 125.197 109.514 125.145C109.462 125.085 109.437 125.012 109.437 124.926V117.346H106.962C106.876 117.346 106.803 117.321 106.742 117.269C106.691 117.209 106.665 117.136 106.665 117.05V116.509C106.665 116.414 106.691 116.341 106.742 116.289C106.803 116.229 106.876 116.199 106.962 116.199H113.175C113.269 116.199 113.342 116.229 113.394 116.289C113.454 116.341 113.484 116.414 113.484 116.509V117.05C113.484 117.136 113.454 117.209 113.394 117.269C113.342 117.321 113.269 117.346 113.175 117.346H110.713V124.926C110.713 125.012 110.683 125.085 110.622 125.145C110.571 125.197 110.498 125.223 110.403 125.223H109.733Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.883 108.066H136.211V130.41C136.211 132.071 134.864 133.418 133.203 133.418H122.891C121.229 133.418 119.883 132.071 119.883 130.41V108.066Z",
    fill: "#D67DB2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.266 125.223C124.197 125.223 124.137 125.197 124.085 125.145C124.034 125.094 124.008 125.034 124.008 124.965C124.008 124.922 124.012 124.875 124.021 124.823L127.218 116.483C127.252 116.397 127.299 116.328 127.359 116.277C127.42 116.225 127.51 116.199 127.63 116.199H128.507C128.618 116.199 128.704 116.225 128.764 116.277C128.833 116.328 128.885 116.397 128.919 116.483L132.103 124.823C132.12 124.875 132.129 124.922 132.129 124.965C132.129 125.034 132.103 125.094 132.052 125.145C132 125.197 131.94 125.223 131.871 125.223H131.214C131.111 125.223 131.033 125.197 130.982 125.145C130.939 125.094 130.909 125.046 130.891 125.004L130.182 123.173H125.954L125.245 125.004C125.237 125.046 125.207 125.094 125.155 125.145C125.104 125.197 125.026 125.223 124.923 125.223H124.266ZM126.328 122.064H129.809L128.068 117.488L126.328 122.064Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.93 108.066H154.258V130.41C154.258 132.071 152.911 133.418 151.25 133.418H140.938C139.276 133.418 137.93 132.071 137.93 130.41V108.066Z",
    fill: "#9A7DD6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.313 125.223C142.244 125.223 142.184 125.197 142.132 125.145C142.08 125.094 142.055 125.034 142.055 124.965C142.055 124.922 142.059 124.875 142.068 124.823L145.264 116.483C145.299 116.397 145.346 116.328 145.406 116.277C145.466 116.225 145.557 116.199 145.677 116.199H146.554C146.665 116.199 146.751 116.225 146.811 116.277C146.88 116.328 146.932 116.397 146.966 116.483L150.15 124.823C150.167 124.875 150.176 124.922 150.176 124.965C150.176 125.034 150.15 125.094 150.098 125.145C150.047 125.197 149.987 125.223 149.918 125.223H149.261C149.157 125.223 149.08 125.197 149.029 125.145C148.986 125.094 148.955 125.046 148.938 125.004L148.229 123.173H144.001L143.292 125.004C143.284 125.046 143.254 125.094 143.202 125.145C143.15 125.197 143.073 125.223 142.97 125.223H142.313ZM144.375 122.064H147.855L146.115 117.488L144.375 122.064Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_15_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.977 108.066H172.305V130.41C172.305 132.071 170.958 133.418 169.297 133.418H158.984C157.323 133.418 155.977 132.071 155.977 130.41V108.066Z",
    fill: "#3747AF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.262 125.223C161.167 125.223 161.094 125.197 161.043 125.145C160.991 125.085 160.965 125.012 160.965 124.926V116.509C160.965 116.414 160.991 116.341 161.043 116.289C161.094 116.229 161.167 116.199 161.262 116.199H164.407C165.378 116.199 166.147 116.427 166.714 116.882C167.282 117.338 167.565 118.012 167.565 118.906C167.565 119.568 167.398 120.109 167.063 120.53C166.736 120.943 166.289 121.231 165.722 121.394L167.707 124.823C167.733 124.875 167.746 124.922 167.746 124.965C167.746 125.034 167.716 125.094 167.655 125.145C167.604 125.197 167.544 125.223 167.475 125.223H166.856C166.71 125.223 166.603 125.184 166.534 125.107C166.465 125.029 166.405 124.952 166.354 124.875L164.484 121.6H162.229V124.926C162.229 125.012 162.198 125.085 162.138 125.145C162.087 125.197 162.014 125.223 161.919 125.223H161.262ZM162.229 120.505H164.355C165 120.505 165.481 120.371 165.799 120.105C166.117 119.83 166.276 119.426 166.276 118.893C166.276 118.369 166.117 117.97 165.799 117.695C165.49 117.42 165.009 117.282 164.355 117.282H162.229V120.505Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.305 108.281L47.6953 108.281L47.6953 45.9766C47.6953 31.738 59.238 20.1953 73.4766 20.1953L146.523 20.1953C160.762 20.1953 172.305 31.738 172.305 45.9766V108.281Z",
    fill: "#384ABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.018,
    cy: 55.752,
    r: 4.18945,
    fill: "#F5F0F0",
    stroke: "white",
    strokeWidth: 0.644531
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2393 63.7012L76.7041 87.6562H147.065L123.862 47.2656L102.163 84.6484L90.2393 63.7012Z",
    fill: "#F5F0F0",
    stroke: "white",
    strokeWidth: 0.644531
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_15_643",
    x: 47.6953,
    y: 108.281,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_15_643",
    x: 65.7422,
    y: 108.281,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_15_643",
    x: 83.7891,
    y: 108.066,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_15_643",
    x: 101.836,
    y: 108.066,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_15_643",
    x: 119.883,
    y: 108.066,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_15_643",
    x: 137.93,
    y: 108.066,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_15_643",
    x: 155.977,
    y: 108.066,
    width: 16.3281,
    height: 25.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15_643"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4325);
export default __webpack_public_path__ + "static/media/Slide 4_3 - 25.785ffd829e5f774f9effaa03dd32cb0f.svg";
export { ForwardRef as ReactComponent };